import { Record } from 'immutable';
import {
  INIT_AUTH,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
  SIGN_IN_ERROR,
  REQUEST_SIGN_IN,
} from './action-types';

export const AuthState = new Record({
  authenticated: false,
  id: null,
  email: '',
  message: '',
  pending: false,
});

export function authReducer(state = new AuthState(), { payload, type }) {
  switch (type) {
    case INIT_AUTH:
    case SIGN_IN_SUCCESS:
      return state.merge({
        authenticated: !!payload,
        id: payload ? payload.uid : null,
        email: payload ? payload.email : '',
        message: '',
        pending: false,
      });

    case REQUEST_SIGN_IN:
      return state.merge({
        pending: true,
        message: '',
      });

    case SIGN_IN_ERROR:
      return state.merge({
        pending: false,
        message: payload.message,
      });

    case SIGN_OUT_SUCCESS:
      return new AuthState();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/core/auth/reducer.js